<template>
  <div ref="videoList" class="video-list" :style="{flexDirection: isVerticalOrientation ? 'column-reverse':'row'}">
    <div class="video-item" v-for="item in videoList" :key="item.id" :video="item">
      <video autoplay playsinline ref="videos" :height="cameraHeight" :muted="item.muted" :id="item.id" :style="{visibility:item.visible?'visible':'hidden'}"></video>
      <div class="user-name">{{item.username}}</div>
      <div class="custom-overlay" @click.stop="log('custom-overlay')">
        <img class="overlay-avatar-image" style="" :src="item.image" v-if="!item.visible && item.image">
      </div>
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client';
import SimpleSignalClient from 'simple-signal-client';
import api from '@/services/api';

export default {
  name: 'webrtc',
  props: {
    roomId: {
      type: String,
      default: 'public-room',
    },
    userName: {
      type: String,
      default: '',
    },
    userImage: {
      type: String,
      default: '',
    },
    socketURL: {
      type: String,
      // default: 'localhost:3000',
      default: 'https://talk.blitzar.com.br/',
    },
    isVerticalOrientation: {
      type: Boolean,
      default: false,
    },
    cameraHeight: {
      type: [Number, String],
      default: 160,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    screenshotFormat: {
      type: String,
      default: 'image/jpeg',
    },
    enableAudio: {
      type: Boolean,
      default: true,
    },
    enableVideo: {
      type: Boolean,
      default: true,
    },
    enableLogs: {
      type: Boolean,
      default: false,
    },
    peerOptions: {
      type: Object, // NOTE: use these options: https://github.com/feross/simple-peer
      default() {
        return {};
      },
    },
    deviceId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      signalClient: null,
      videoList: [],
      canvas: null,
      socket: null,
      username: 'Elliot Alderson',
      peers: [],
      localStream: null,
      _roomlId: '',
    };
  },
  methods: {
    async join() {
      const that = this;
      console.log('join');
      this.socket = io(this.socketURL, { timeout: 1000, reconnectionDelayMax: 1000, rejectUnauthorized: false, transports: ['websocket'] });
      this.signalClient = new SimpleSignalClient(this.socket, { connectionTimeout: 1000 });
      let constraints = {
        video: {
          width: { min: 640, ideal: 640, max: 1920 },
          height: { min: 480, ideal: 480, max: 1080 },
        },
        audio: true,
      };
      if (that.deviceId && that.enableVideo) {
        constraints.video = { deviceId: { exact: that.deviceId } };
      }
      this.localStream = await navigator.mediaDevices.getUserMedia(constraints);
      console.log('getUserMedia stream opened', this.localStream);
      this.joinedRoom(this.localStream, true, JSON.stringify({ username: that.userName, image: that.userImage }));

      this.signalClient.once('discover', discoveryData => {
        console.log('discovered', { discoveryData });
        that.peers = discoveryData.peers;

        async function connectToPeer(peerID, idx) {
          if (peerID == that.socket.id) return;
          try {
            console.log('Connecting to peer');
            const { peer } = await that.signalClient.connect(peerID, JSON.stringify({ username: that.userName, image: that.userImage }), that.peerOptions);
            console.log('connected to', peerID, that.videoList.length);

            that.videoList.forEach(v => {
              if (v.isLocal) {
                that.onPeer(peer, v.stream, JSON.stringify({ username: that.peers[idx].user_name, image: that.peers[idx].image }));
              }
            });
          } catch (e) {
            that.log('Error connecting to peer');
          }
        }
        discoveryData.peers.forEach((peer, idx) => connectToPeer(peer.user_id, idx));
        that.$emit('opened-room', that.roomId);
      });
      this.signalClient.on('request', async request => {
        console.log('requested', { request });
        const { peer } = await request.accept({}, that.peerOptions);
        console.log('accepted', request.metadata);
        that.videoList.forEach(v => {
          if (v.isLocal) {
            that.onPeer(peer, v.stream, request.metadata);
          }
        });
      });
      this.signalClient.discover(JSON.stringify({ roomId: that.roomId, user_name: that.userName, image: that.userImage }));
    },
    onPeer(peer, localStream, metadata) {
      const that = this;
      console.log('onPeer', metadata);
      peer.addStream(localStream);
      peer.on('stream', remoteStream => {
        console.log('peer on stream:', remoteStream.id);
        that.joinedRoom(remoteStream, false, metadata);
        peer.on('close', () => {
          let newList = [];
          that.videoList.forEach(function (item) {
            if (item.id !== remoteStream.id) {
              newList.push(item);
            }
          });
          that.videoList = newList;
          that.$emit('left-room', remoteStream.id);
        });
        peer.on('error', err => {
          that.log('peer error ', err);
        });
      });
      peer.on('data', data => {
        let parsed = new TextDecoder('utf-8').decode(data);
        // console.log('peer on data: ', { parsed });
        try {
          parsed = JSON.parse(parsed);
          if (parsed.action == 'startScreenSharing') console.log('startScreenSharing');
          if (parsed.action == 'stopScreenSharing') that.videoList = that.videoList.filter(video => video.id != parsed.id);
          if (parsed.action == 'peerActivatedVideo') {
            that.videoList = that.videoList.map(video => {
              if (!video.isLocal && video.id == parsed.id) {
                video.visible = true;
                // video.stream.getVideoTracks()[0].enabled = true;
              }
              return video;
            });
          }
          if (parsed.action == 'peerDeactivatedVideo') {
            // console.log('peerDeactivatedVideo');
            that.videoList = that.videoList.map(video => {
              if (!video.isLocal && video.id == parsed.id) {
                video.visible = false;
                // video.stream.getVideoTracks()[0].enabled = false;
              }
              return video;
            });
          }
        } catch (error) {}
      });
    },
    joinedRoom(stream, isLocal, metadata) {
      console.log('META', metadata);
      if (typeof metadata === 'string') metadata = JSON.parse(metadata);
      else metadata = 'empty metadata';
      const that = this;
      let found = that.videoList.find(video => {
        return video.id === stream.id;
      });
      if (found === undefined) {
        let video = {
          id: stream.id,
          visible: true,
          muted: isLocal,
          stream: stream,
          isLocal: isLocal,
          username: metadata.username ? metadata.username : '',
          image: metadata.image ? metadata.image : '',
        };

        that.videoList.push(video);
      }

      this.$nextTick(() => {
        for (let i = 0; i < that.$refs.videos.length; i++) {
          if (that.$refs.videos[i].id === stream.id) {
            that.$refs.videos[i].srcObject = stream;
            break;
          }
        }
        that.$emit('joined-room', stream.id, that.videoList.length);
        // console.log('joined-room videoList length: ', that.videoList.length);
      });
    },
    getVideosCount() {
      return this.videoList.length;
    },
    toggleOrientation(isVertical, width, height) {
      let streamCount = this.videoList.length;
      if (streamCount <= 1) return { width: width, height: height };
      let tempWidth = width;
      return { width: height, height: tempWidth };
    },
    toggleLocalStreamAudioTrack(enable) {
      this.localStream.getAudioTracks()[0].enabled = enable;
      console.log('toggleLocalStreamAudioTrack', this.localStream.getAudioTracks()[0].enabled);
    },
    toggleLocalStreamVideoTrack(enable) {
      this.localStream.getVideoTracks()[0].enabled = enable;
      console.log('toggleLocalStreamVideoTrack', this.localStream.getVideoTracks()[0].enabled);
      this.videoList = this.videoList.map(v => {
        if (v.isLocal) {
          v.visible = enable;
          v.stream.getVideoTracks()[0].enabled = enable;
        }
        return v;
      });
      if (enable) {
        this.signalClient.peers().forEach(peer => peer.send(JSON.stringify({ action: 'peerActivatedVideo', id: this.localStream.id })));
      } else {
        this.signalClient.peers().forEach(peer => peer.send(JSON.stringify({ action: 'peerDeactivatedVideo', id: this.localStream.id })));
      }
    },
    leave() {
      console.log('ran leave()');
      api.post(`sessionAction/`, {
        action: 'User left talk room',
        properties: JSON.stringify({ room_id: this._roomlId }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
      this.videoList.forEach(v => v.stream.getTracks().forEach(t => t.stop()));
      this.videoList = [];
      this.signalClient.peers().forEach(peer => peer.removeAllListeners());
      this.signalClient.destroy();
      this.signalClient = null;
      this.socket.destroy();
      this.socket = null;
    },
    capture() {
      return this.getCanvas().toDataURL(this.screenshotFormat);
    },
    getCanvas() {
      let video = this.$refs.videos[0];
      if (video !== null && !this.ctx) {
        let canvas = document.createElement('canvas');
        canvas.height = video.clientHeight;
        canvas.width = video.clientWidth;
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
      }
      const { ctx, canvas } = this;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas;
    },
    async shareScreen() {
      let that = this;
      if (navigator.mediaDevices == undefined) {
        that.log('Error: https is required to load cameras');
        return;
      }

      try {
        let screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
        this.joinedRoom(screenStream, true);
        that.$emit('share-started', screenStream.id);
        that.signalClient.peers().forEach(p => that.onPeer(p, screenStream));
      } catch (e) {
        that.log('Media error: ' + JSON.stringify(e));
      }
    },
    log(message, data) {
      if (this.enableLogs) {
        console.log(message);
        if (data != null) {
          console.log(data);
        }
      }
    },
    videoClicked(e) {
      console.log('videoClicked', { e });
    },
  },
  mounted() {
    this.$store.commit('setUserInMeeting', true);
    document.activeElement.blur();
    this.$refs.videoList.focus();
    console.log('sessionAction', this.roomId);
    api.post(`sessionAction/`, {
      action: 'User joined talk room',
      properties: JSON.stringify({ room_id: this.roomId }),
      userid: this.$store.state.user.id,
      sessionid: this.$store.state.user.token,
      event_id: this.$store.state.eventId,
    });
    this._roomlId = this.roomId;
  },
  beforeDestroy() {
    this.$store.commit('setUserInMeeting', false);
  },
};
</script>
<style lang="scss" scoped>
.video-list {
  background: transparent;
  height: auto;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  flex-wrap: nowrap;
}

.video-item {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 4px;
}
.video-item video {
  // min-height: 180px;
  transform: scaleX(-1);
  border-radius: 10px;
  width: 100%;
  object-fit: contain;
  // &:active {
  //   pointer-events: none;
  // }
}
::-webkit-media-controls {
  transform: scaleX(-1) !important;
}
video::-webkit-media-controls-play-button,
video::-webkit-media-controls-pausebutton {
  display: none;
}

audio::-webkit-media-controls-timeline,
video::-webkit-media-controls-timeline {
  display: none;
}
.user-name {
  position: absolute;
  top: 2px;
  right: 6px;
  padding: 0 4px;
  background: #2229;
  color: #dddd;
  font-size: 16px;
  @include media('<=phone') {
    font-size: 14px;
  }
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
}

.custom-overlay {
  position: absolute;
  inset: 0;
  background: transparent;
  user-select: auto;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  @include media('<=phone') {
    inset: 0;
  }

  .overlay-avatar-image {
    position: relative;
    width: 30%;
    margin: auto;
    border-radius: 50%;
  }
}
</style>
